var _rect, _rect2, _g, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloaticonsearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.122559,
    y: 0.722656,
    width: 89.1334,
    height: 89.1334,
    rx: 10.9133,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2771,
    y: 13.2822,
    width: 64.8243,
    height: 64.014,
    rx: 10.8336,
    fill: "#F2F1FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1285_22751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1887 55.0553C49.8186 55.0553 55.1932 49.815 55.1932 43.3509C55.1932 36.8867 49.8186 31.6465 43.1887 31.6465C36.5588 31.6465 31.1842 36.8867 31.1842 43.3509C31.1842 49.815 36.5588 55.0553 43.1887 55.0553Z",
    stroke: "#6F4EF6",
    strokeWidth: 3.24121,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1941 57.9814L51.6666 51.6172",
    stroke: "#6F4EF6",
    strokeWidth: 3.24121,
    strokeLinecap: "square"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.255306,
    y: 0.855404,
    width: 88.8679,
    height: 88.8679,
    rx: 10.7806,
    stroke: "white",
    strokeOpacity: 0.05,
    strokeWidth: 0.265495
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1285_22751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.4121,
    height: 31.6018,
    fill: "white",
    transform: "translate(28.4832 29.4883)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloaticonsearch);
export default __webpack_public_path__ + "static/media/float icon search.6a65afabec617a839385567eddca3eb0.svg";
export { ForwardRef as ReactComponent };